export const formatIDR = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "Rp 0";
  const sign = n < 0 ? "-" : "";
  const abs = Math.abs(Math.round(Number(n)));
  const s = abs.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${sign}Rp ${s}`;
};

export const formatShortIDR = (n) => {
  if (!n && n !== 0) return "Rp 0";
  const abs = Math.abs(n);
  if (abs >= 1_000_000_000) return `Rp ${(n / 1_000_000_000).toFixed(1)}M`;
  if (abs >= 1_000_000) return `Rp ${(n / 1_000_000).toFixed(1)}Jt`;
  if (abs >= 1_000) return `Rp ${(n / 1_000).toFixed(0)}rb`;
  return formatIDR(n);
};

export const formatDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString("id-ID", { day: "numeric", month: "short", year: "numeric" });
};
